// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import {
  deepPurple700,
} from 'material-ui/styles/colors';

// Local Variables
const checkboxStyles = {
  fill: deepPurple700,
};

// Component Definition
class SingleAttendee extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onToggle: PropTypes.func,
  }

  static defaultProps = {
    checked: false,
  }

  handleToggle = () => {
    const {
      id,
      onToggle,
    } = this.props;

    onToggle(id);
  }

  render() {
    const {
      checked,
      name,
    } = this.props;

    return (
      <Checkbox
        checked={checked}
        onCheck={this.handleToggle}
        iconStyle={checkboxStyles}
        label={name}
      />
    );
  }
}

export default SingleAttendee;



/** WEBPACK FOOTER **
 ** ./src/dashboard/update-attendance/SingleAttendee.js
 **/